var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup4421(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 2.5,
    fill: "#234492"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8868 23C21.5911 23 21.3131 22.8847 21.1002 22.6747L15.5 17.0716L9.89976 22.6718C9.68983 22.8817 9.41189 22.997 9.11325 22.997C8.81461 22.997 8.53666 22.8817 8.32377 22.6688C7.89208 22.2371 7.89208 21.5305 8.32377 21.0958L13.927 15.4985L8.32673 9.89829C7.89503 9.46363 7.89503 8.75695 8.32673 8.32525C8.53666 8.11532 8.81756 8 9.11325 8C9.40893 8 9.68983 8.11532 9.89976 8.32525L15.5 13.9284L21.1032 8.32525C21.3131 8.11532 21.5911 8 21.8897 8C22.1884 8 22.4663 8.11532 22.6762 8.32525C23.1079 8.75695 23.1079 9.46363 22.6762 9.89829L17.0701 15.4985L22.6703 21.0988C23.102 21.5334 23.102 22.2401 22.6703 22.6718C22.4604 22.8817 22.1795 22.997 21.8838 22.997L21.8868 23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4421);
export default __webpack_public_path__ + "static/media/Group 442 (1).fdce70d148762d0ee142f305f32da38f.svg";
export { ForwardRef as ReactComponent };